import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ISimTypeModel } from '@apps-common/types/management/sim-type'

export const getSimType = async (typeId: string): Promise<ISimTypeModel> =>
  axios.get(`/management/simtype/getsimtype?typeId=${typeId}`).then((res) => res.data?.data)

type QueryFnType = typeof getSimType

type Props = {
  config?: QueryConfig<QueryFnType>
  typeId: string
}

export const useManagementGetSimType = ({ config, typeId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: ['getSimType', typeId],
    queryFn: () => getSimType(typeId)
  })
